import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, PLATFORM_ID, inject, signal } from "@angular/core";
import { REQUEST } from "../../../express.tokens";
import { environment } from "src/environments/environment";
import { isPlatformServer } from "@angular/common";
import { BehaviorSubject, Observable, Subject, tap } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class HomePageService {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private request = inject(REQUEST, { optional: true })!;
  private planName: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public data$: Observable<string> = this.planName.asObservable();
  supplier: any;
  // apiUrl = environment.apiUrl;
  apiUrl = environment.apiUrl;
  configurations: any = [];
  role: any;
  siteCatalog: any;
  adminToken;
  private categoryDataSubject = new BehaviorSubject<any>(null);
  categoryData$ = this.categoryDataSubject.asObservable();
  public refreshCart = signal<boolean>(false);
  FetchForBaseUrl(baseUrl: any) {
    let params = new HttpParams().set("baseUrl", baseUrl);
    return this.http.get(`${this.apiUrl}Settings/FetchForBaseUrl`, {
      params: params,
    });
  }
  FetchItemsForHome(pageNumber: any, pageSize: any) {
    let params: any = { pageNumber, pageSize };
    !localStorage.getItem("currentUser") && (params.isGuest = true);
    return this.http.get(`${this.apiUrl}Home/FetchItemsForHome`, {
      params: params,
    });
  }
  // FetchExternalLinks(siteID: any) {
  //   return this.http.get(`${this.apiUrl}Home/FetchExternalLinks?siteID=${siteID}`)
  // }
  FetchForSearch(model: any) {
    // let params = new HttpParams();
    // // params = params.append('siteCatalog', model?.siteCatalog)
    // params = params.append('hintX', model?.hintX)
    // params = params.append('pageNumber', model?.pageNumber)
    // params = params.append('pageSize', model?.pageSize)
    // params = params.append('isVendor', model?.isVendor)
    // params = params.append('imageType', model?.imageType)
    !localStorage.getItem("currentUser") && (model.isGuest = true);
    return this.http.get(`${this.apiUrl}Home/FetchForSearch`, {
      params: model,
    });
  }
  FetchBannerImages() {
    return this.http.get(`${this.apiUrl}Home/FetchBannerImages`);
  }

  FetchForCatalogItem(catalogItem: any) {
    let params = new HttpParams().set("catalogItem", catalogItem);
    return this.http.get(`${this.apiUrl}Home/FetchForCatalogItem`, {
      params: params,
    });
  }
  FetchForCatalogItemAddress(catalogItem: any) {
    let params = new HttpParams().set("catalogItem", catalogItem);
    return this.http.get(`${this.apiUrl}Home/FetchForCatalogItemAddress`, {
      params: params,
    });
  }
  FetchForCatalogItemThumbnails(catalogItem: any) {
    let params = new HttpParams({
      fromObject: {
        catalogItemStyle: catalogItem,
        // imageType: type
      },
    });
    return this.http.get(`${this.apiUrl}Home/FetchForCatalogItemThumbnails`, {
      params: params,
    });
  }
  FetchCatalogItemFeaturedTop5(
    section: any,
    catalogItem: any,
    productCategory: any
  ) {
    let params = new HttpParams();
    // params = params.append('siteCatalog', siteCatalog)
    params = params.append("section", section);
    params = params.append("catalogItem", catalogItem);
    params = params.append("productCategory", productCategory);
    return this.http.get(`${this.apiUrl}Home/FetchCatalogItemFeaturedTop5`, {
      params: params,
    });
  }
  // FetchForFeatured(model: any) {
  //   let params = new HttpParams();
  //   params = params.append('aSiteCatalog', model?.aSiteCatalog)
  //   params = params.append('aSection', model?.aSection)
  //   params = params.append('aPageNumber', model?.aPageNumber)
  //   params = params.append('aPageSize', model?.aPageSize)
  //   params = params.append('systemUser', model?.systemUser)
  //   params = params.append('imageType', model?.imageType)
  //   return this.http.get(`${this.apiUrl}Home/FetchForFeatured`, { params: params })
  // }
  FetchForRelatedItems(model: any) {
    return this.http.get(`${this.apiUrl}Home/FetchRelatedItemsForCatalogItem`, {
      params: model,
    });
  }
  // FetchForSection(model: any) {
  //   let params = new HttpParams();
  //   params = params.append('aSiteCatalog', model?.aSiteCatalog)
  //   params = params.append('aSection', model?.aSection)
  //   params = params.append('aPageNumber', model?.aPageNumber)
  //   params = params.append('aPageSize', model?.aPageSize)
  //   params = params.append('systemUser', model?.systemUser)
  //   params = params.append('imageType', model?.imageType)
  //   return this.http.get(`${this.apiUrl}Home/FetchForSection`, { params: params })
  // }
  FetchForProductCategoryImages(productCategory) {
    if (productCategory) {
      let params = new HttpParams();
      params = params.append("productCategory", productCategory);
      return this.http.get(`${this.apiUrl}Home/FetchForProductCategoryImages`, {
        params: params,
      });
    } else {
      return this.http.get(`${this.apiUrl}Home/FetchForProductCategoryImages`);
    }
  }
  SystemUser(model) {
    return this.http.post(`${this.apiUrl}Accounts/SystemUser`, model);
  }
  Login(model: any) {
    return this.http.post(`${this.apiUrl}Accounts/SystemUser/Login`, model);
  }
  ForgotPassword(model: any) {
    // let params = new HttpParams();
    // params = params.append('systemUser', model?.systemUser)
    // params = params.append('site', model?.site)
    // params = params.append('EmailAddress', model)
    // params = params.append('siteX', model?.siteX)
    // params = params.append('baseUrl', model?.baseUrl)
    return this.http.post(
      `${this.apiUrl}Accounts/SystemUser/ForgotPassword`,
      model
    );
  }
  FetchAllSectionsForSite() {
    return this.http.get(`${this.apiUrl}Home/FetchPublishedSectionsForSite`);
  }

  OnlineSubmission(model: any) {
    return this.http.post(`${this.apiUrl}Accounts/OnlineSubmission`, model);
  }
  FetchCategoriesForSection(section) {
    let params = new HttpParams();
    params = params.append("section", section);

    return this.http.get(`${this.apiUrl}Admin/FetchCategoriesForSection`, {
      params: params,
    });
  }
  FetchPublishedCategoriesForSection(section) {
    let params = new HttpParams();
    params = params.append("section", section);

    return this.http.get(
      `${this.apiUrl}Home/FectchPublishedCategoriesForSection`,
      { params: params }
    );
  }
  FetchForCatalogItemStyle(catalogItemStyle) {
    let params = new HttpParams();
    params = params.append("catalogItemStyle", catalogItemStyle);
    return this.http.get(`${this.apiUrl}WebOrder/FetchForCatalogItemStyle`, {
      params: params,
    });
  }

  // not in use
  // confirmOrder(model) {
  //   return this.http.put(`${this.apiUrl}Cart/FinancialCommit`, null, { params: model })
  // }
  // not in use
  // InsertNewsLetter(model) {
  //   return this.http.post(`${this.apiUrl}Home/InsertNewsLetter`, model)
  // }
  fetchVendorsForSite(params) {
    // return this.http.get(`${this.apiUrl}Home/FetchVendorsForSite?RoleType=${param}&vendorId=${vendorId}&searchHint=${searchHintSupplier == undefined ? null : searchHintSupplier}`);
    return this.http.get(`${this.apiUrl}Home/FetchVendorsForSite`, {
      params: params,
    });
  }
  FetchForFilter(params: any) {
    !localStorage.getItem("currentUser") && (params.isGuest = true);
    return this.http.get(`${this.apiUrl}Home/FetchForFilter`, {
      params: params,
    });
  }

  FetchOnlineSubmission(model: any) {
    return this.http.get(
      `${this.apiUrl}Accounts/OnlineSubmission?onlineSubmission=${model.onlineSubmission}&siteID=${model.siteID}`
    );
  }
  Vendor(model: any) {
    return this.http.post(`${this.apiUrl}Accounts/Vendor`, model);
  }
  fetchVendor(Vendor: any) {
    return this.http.get(
      `${this.apiUrl}Vendor/FetchVendorAgreementDocuments?vendor=${Vendor}`
    );
  }
  FetchVendorAgreementDocumentsForAdmin(Vendor: any) {
    // const headers = new HttpHeaders({
    //   'token': this.adminToken,
    //   'Content-Type': 'application/json',
    // });
    return this.http.get(
      `${this.apiUrl}Admin/FetchVendorAgreementDocuments?vendor=${Vendor}`
    );
  }
  updateVendor(updateSystemUserModel: any) {
    return this.http.put(
      `${this.apiUrl}Accounts/Vendor`,
      updateSystemUserModel
    );
  }
  fetchVendorAgreement(absoluteUrls) {
    const urls = {
      urls: absoluteUrls,
    };
    return this.http.post(`${this.apiUrl}Settings/ConvertToBase64`, urls);
  }
  AddCatalogItemReview(model: any) {
    return this.http.post(`${this.apiUrl}Home/CatalogItemReview`, model);
  }
  FetchCataLogItemRatingInPercent(catalogItem: any) {
    let params = new HttpParams().set("catalogItem", catalogItem);
    return this.http.get(`${this.apiUrl}Home/FetchCataLogItemRatingInPercent`, {
      params: params,
    });
  }
  FetchCataLogItemReviews(model: any) {
    return this.http.get(`${this.apiUrl}Home/FetchCataLogItemReviews`, {
      params: model,
    });
  }
  AddCatalogItemFAQ(model: any) {
    return this.http.post(`${this.apiUrl}Home/AddCatalogItemFAQ`, model);
  }

  AddCatalogItemAnswer(model: any) {
    return this.http.post(`${this.apiUrl}Home/AddCatalogItemAnswer`, model);
  }
  FetchAllCataLogItemFAQ(model: any) {
    return this.http.get(`${this.apiUrl}Home/FetchAllCataLogItemFAQ`, {
      params: model,
    });
  }
  FetchForCatalogItemByName(model) {
    return this.http.get(`${this.apiUrl}Home/FetchCatalogItemByName`, {
      params: model,
    });
  }
  // not in use
  // UpdateCatalogItemFAQ(model: any) {
  //   return this.http.put(`${this.apiUrl}Home/UpdateCatalogItemFAQ`, model)
  // }
  DeleteCatalogItemAnswer(item) {
    return this.http.delete(
      `${this.apiUrl}Home/DeleteCatlogitemAnswer?catalogItemAnswer=${item}`
    );
  }
  UpdateCatalogItemAnswer(model: any) {
    return this.http.put(`${this.apiUrl}Home/UpdateCatalogItemAnswer`, model);
  }
  FetchPublishedSectionsForSite() {
    return this.http.get(`${this.apiUrl}Home/FetchPublishedSectionsForSite`);
  }
  getExchangePolicies(catalogItem: number, category: number) {
    return this.http.get(
      `${this.apiUrl}Vendor/FetchReturnPoliciesForCatalogItem?catalogItem=${catalogItem}&productCategory=${category}`
    );
  }
  saveCustomerAsVendor(model) {
    let baseUrl: string = environment.production
      ? this.getCurrentUrl()
      : environment.baseUrl;
    model.append("BaseUrl", baseUrl);
    return this.http.post(
      `${this.apiUrl}Accounts/RegisterCustomerAsVendor`,
      model
    );
  }
  GetDynamicHeader() {
    return this.http.get(`${this.apiUrl}Home/GetDynamicHeader`);
  }

  FetchAgreementDocuments() {
    return this.http.get(`${this.apiUrl}Home/FetchAgreementDocuments`);
  }
  UploadDocument(formData: FormData) {
    return this.http.post(`${this.apiUrl}Accounts/UploadDocument`, formData);
  }
  SendOtp(emailOrPhone: string) {
    let currnetUser = localStorage.getItem("currentUser");
    let baseUrl: string = environment.production
      ? this.getCurrentUrl()
      : environment.baseUrl;
    if (!currnetUser) {
      return this.http.post(
        `${this.apiUrl}Accounts/Vendor/sendOtp?emailOrPhone=${emailOrPhone}&BaseUrl=${baseUrl}`,
        null
      );
    } else {
      var model = {
        emailOrPhone,
        BaseUrl: baseUrl,
      };
      return this.http.post(
        `${this.apiUrl}Accounts/Vendor/SendOtpToVerifyCustomerAsVendor`,
        null,
        { params: model }
      );
    }
  }
  getCurrentUrl(): string {
    if (isPlatformServer(this.platformId)) {
      // If SSR, get the URL from the request object
      return this.request.hostname;
    } else {
      // If browser, get the URL from the location service
      return window.location.host;
    }
  }
  VerifyOtp(CellPhone: string, OtpCode: string) {
    return this.http.post(
      `${this.apiUrl}Accounts/Vendor/VerifyOtp?CellPhone=${CellPhone}&OtpCode=${OtpCode}`,
      null
    );
  }
  SendOtpForVendorEdit(emailOrPhone: string) {
    return this.http.post(
      `${this.apiUrl}Accounts/VendorEdit/sendOtp?emailOrPhone=${emailOrPhone}`,
      null
    );
  }

  VerifyOtpForVendorEdit(CellPhone: string, OtpCode: string) {
    return this.http.put(
      `${this.apiUrl}Accounts/VendorEdit/VerifyOtp?CellPhone=${CellPhone}&OtpCode=${OtpCode}`,
      null
    );
  }
  FetchItemsForDashboard(category, subCategory) {
    return this.http.get(
      `${this.apiUrl}Home/FetchTop4DiscountedProductsForHome?productcategory=${category}&isCatalogItem=${subCategory}`
    );
  }
  getNewDynamicHeader() {
    return this.http.get(`${this.apiUrl}Home/GetNewDynamicHeader`);
  }
  FetchCategoriesForFilter() {
    return this.http.get(`${this.apiUrl}Home/FetchCategoriesForFilter`);
  }
  fetchCatalogItemStylesForCart(catalogItemStyles) {
    return this.http.get(
      `${this.apiUrl}Home/fetchCatalogItemStylesForCart?catalogItemStyles=${catalogItemStyles}`
    );
  }

  FetchFeaturedItems(model) {
    return this.http.get(`${this.apiUrl}Home/FetchFeaturedItems`, {
      params: model,
    });
  }
  VerifyCustomerAsVendor(emailOrPhone) {}
  FetchCatalogItemStylesForOtherVendors(model: any) {
    return this.http.get(
      `${this.apiUrl}Home/FetchCatalogItemStylesForOtherVendors`,
      { params: model }
    );
  }
  FetchCategoriesForDashboard(section) {
    return this.http.get(
      `${this.apiUrl}Home/FetchCategoriesForDashboard?section=${section}`
    );
  }
  sendEnquiry(enquiryData) {
    return this.http.post(
      `${this.apiUrl}WebOrder/CatalogItem/SendInquiry`,
      enquiryData,
      { responseType: "text" }
    );
  }

  fetchCategoriesFooterAndDashboard(
    category: number,
    subCategory: boolean
  ): void {
    if (!this.categoryDataSubject.value) {
      this.http
        .get(
          `${this.apiUrl}Home/FetchTop4DiscountedProductsForHome?productcategory=${category}&isCatalogItem=${subCategory}`
        )
        .pipe(
          tap((data) => {
            this.categoryDataSubject.next(data);
          })
        )
        .subscribe({
          next: () => {},
          error: (err) => console.error("API Call Error:", err), // Debugging API errors
        });
    } else {
      console.log("Using cached data:", this.categoryDataSubject.value);
    }
  }

  getCategoriesFooterAndDashboard(): Observable<any> {
    return this.categoryData$;
  }
  GetHomeStatus() {
    return this.http.get(`${this.apiUrl}Home/FetchHomeStatus`);
  }
  FetchPricingPlans() {
    return this.http.get(`${this.apiUrl}Settings/FetchPricingPlans`);
  }

  setPlan(newData: string): void {
    this.planName.next(newData);
  }

  getPlan(): string {
    return this.planName.getValue();
  }
  fetchRecentlyViewed(){
     return this.http.get(
       `${this.apiUrl}WebOrder/FetchRecentlyViewed`
     );
  }
}
